// store/index.js
import { createStore } from 'vuex';
import app from './modules/app';
import permission from './modules/permission';
import user from './modules/user';
import stock from './modules/stock';
import notifications from './modules/notifications';
import getters from './getters';

const store = createStore({
  modules: {
    app,
    permission,
    user,
    stock,
    notifications,
  },
  getters
});

export default store;
